module.exports = __webpack_public_path__ + "img/outdoor.341be951.jpg";